import { render, staticRenderFns } from "./ProductRelatedProductSmall.vue?vue&type=template&id=48e3e34c"
import script from "./ProductRelatedProductSmall.vue?vue&type=script&lang=js"
export * from "./ProductRelatedProductSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports